<template>
  <div class="test">
    <div
      :class="{
        wrapper: open,
        wrapperClose: !open && !phone,
        wrapperPhone: phone && !open,
      }"
    >
      <div
        :class="{
          sidebarOpen: open,
          sidebarClose: !open && !phone,
          sidebarPhone: phone && !open,
        }"
      >
        <div class="menu-button-patch"></div>
        <div
          class="menubutton"
          @click="
            open = !open;
            showManageItems = false;
            showManagePlanItems = false;
          "
        >
          <v-icon
            v-if="phone && open"
            style="color: var(--button-color); font-size: 3.2rem"
            >arrow_back</v-icon
          >
          <v-icon v-else style="color: var(--button-color); font-size: 3.2rem"
            >menu</v-icon
          >
        </div>
        <div v-if="phone && !open"></div>
        <div v-else @click="gotoDashboard" class="logo">
          <div v-if="open">
            <img src="@/assets/newDesign/logo_color.svg" style="width: 17rem" />
          </div>
          <!--<img v-if="open" src="../../assets/trimatra_img/logo.png">-->
          <div v-else>
            <img
              v-if="!phone"
              style="width: 4.5rem; height: auto"
              src="@/assets/newDesign/logo.svg"
            />
          </div>
        </div>
        <div
          v-if="open || phone"
          :class="{
            profile: open,
            profileClose: !open && !phone,
            profilePhone: phone && !open,
          }"
        >
          <div>
            <b>{{ user.name }}</b>
          </div>
          <div>{{ user.email }}</div>
        </div>
        <div class="items">
          <div
            v-if="havePermission('dashboard')"
            v-bind:class="{ active: isActive('dashboard') }"
            @click="gotoDashboard"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('dashboard') }"
              class="item-icon"
              size="20"
              >mdi-view-dashboard</v-icon
            >
            <span v-if="open">Dashboard</span>
          </div>
          <div
            v-if="havePermission('manage_job')"
            v-bind:class="{ active: isActive('pending-jobs') }"
            @click="goToPendingJobs"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('pending-jobs') }"
              class="item-icon"
              size="20"
              >mdi-briefcase</v-icon
            >
            <span v-if="open">Manage Jobs</span>
          </div>
          <div
            v-if="havePermission('company')"
            v-bind:class="{ active: isActive('manage-users') }"
            @click="openMenu('manage-users')"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('manage-users') }"
              class="item-icon"
              size="20"
              >mdi-briefcase-account</v-icon
            >
            <span v-if="open">Companies</span>
            <span v-if="open">
              <v-icon class="arrow-icon" v-if="!showManageItems"
                >expand_more</v-icon
              >
              <v-icon class="arrow-icon" v-else>expand_less</v-icon>
            </span>
          </div>

          <div
            v-bind:class="{ active: isActive('new') }"
            @click="goToManageUsers('new')"
            v-if="showManageItems && havePermission('new_company')"
            class="item sub"
          >
            <span>Pending</span>
          </div>
          <div
            v-bind:class="{ active: isActive('duplicate') }"
            @click="goToManageUsers('duplicate')"
            v-if="showManageItems && havePermission('duplicate_company_name')"
            class="item sub"
          >
            <span>Duplicate (Name)</span>
          </div>
          <div
            v-bind:class="{ active: isActive('duplicate-mail') }"
            @click="goToManageUsers('duplicate-mail')"
            v-if="showManageItems && havePermission('duplicate_company_email')"
            class="item sub"
          >
            <span>Duplicate (Mail)</span>
          </div>
          <div
            v-bind:class="{ active: isActive('expired') }"
            @click="goToManageUsers('expired')"
            v-if="showManageItems && havePermission('expired_company')"
            class="item sub"
          >
            <span>Plan Expired</span>
          </div>
          <div
            v-bind:class="{ active: isActive('requested') }"
            @click="goToManageUsers('requested')"
            v-if="showManageItems && havePermission('requested_company')"
            class="item sub"
          >
            <span>Plan Requested</span>
          </div>
          <div
            v-bind:class="{ active: isActive('registered') }"
            @click="goToManageUsers('registered')"
            v-if="showManageItems && havePermission('registered_company')"
            class="item sub"
          >
            <span>Registered (All)</span>
          </div>
          <div
            v-if="havePermission('plan')"
            v-bind:class="{ active: isActive('manage-plans') }"
            @click="openMenu('manage-plans')"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('manage-plans') }"
              class="item-icon"
              size="20"
              >mdi-star-circle</v-icon
            >
            <span v-if="open">Plans</span>
            <span v-if="open">
              <v-icon class="arrow-icon" v-if="!showManagePlanItems"
                >expand_more</v-icon
              >
              <v-icon class="arrow-icon" v-else>expand_less</v-icon>
            </span>
          </div>
          <div
            v-bind:class="{ active: isActive('add') }"
            @click="goToManagePlans('add')"
            v-if="showManagePlanItems && havePermission('plan')"
            class="item sub"
          >
            <span>Add New</span>
          </div>
          <div
            v-bind:class="{ active: isActive('published') }"
            @click="goToManagePlans('published')"
            v-if="showManagePlanItems && havePermission('plan')"
            class="item sub"
          >
            <span>Published</span>
          </div>
          <div
            v-bind:class="{ active: isActive('saved') }"
            @click="goToManagePlans('saved')"
            v-if="showManagePlanItems && havePermission('plan')"
            class="item sub"
          >
            <span>Saved</span>
          </div>
          <div
            v-if="havePermission('post_job')"
            v-bind:class="{ active: isActive('post-a-job') }"
            @click="goToPostAJob"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('post-a-job') }"
              class="item-icon"
              size="20"
              >mdi-briefcase-plus</v-icon
            >
            <span v-if="open">Post a job</span>
          </div>
          <div
            v-if="havePermission('create_company')"
            v-bind:class="{ active: isActive('create-company') }"
            @click="goToCreateCompany"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('create-company') }"
              class="item-icon"
              size="20"
              >mdi-briefcase-plus</v-icon
            >
            <span v-if="open">Create Company Account</span>
          </div>
          <div
            v-if="havePermission('handover_company')"
            v-bind:class="{ active: isActive('handover') }"
            @click="goHandoverCompany"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('handover') }"
              class="item-icon"
              size="20"
              >mdi-briefcase-plus</v-icon
            >
            <span v-if="open">Handover Company</span>
          </div>
          <div
            v-if="havePermission('company_job')"
            v-bind:class="{ active: isActive('all-jobs') }"
            @click="gotoAllJobs"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('all-jobs') }"
              class="item-icon"
              size="20"
              >mdi-briefcase</v-icon
            >
            <span v-if="open">All jobs (Company)</span>
          </div>
          <div
            v-if="havePermission('message_candidate')"
            v-bind:class="{ active: isActive('message') }"
            @click="goToMessagePage"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('message') }"
              class="item-icon"
              size="20"
              >mdi-message</v-icon
            >
            <span v-if="open">Messages</span>
          </div>
          <div
            v-if="havePermission('server_log')"
            v-bind:class="{ active: isActive('mobile-log') }"
            @click="goToMobileLog"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('mobile-log') }"
              class="item-icon"
              size="20"
              >mdi-message</v-icon
            >
            <span v-if="open">Mobile Log</span>
          </div>
          <div
            v-if="havePermission('error_log')"
            v-bind:class="{ active: isActive('error-log') }"
            @click="goToErrorLog"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('error-log') }"
              class="item-icon"
              size="20"
              >mdi-message</v-icon
            >
            <span v-if="open">Error Log</span>
          </div>
          <div
            v-if="phone"
            style="padding-left: 2.5rem"
            class="item"
            @click="signOutConfirmation"
          >
            <v-icon color="#121212;" size="22" style="margin-right: 1.2rem"
              >power_settings_new</v-icon
            >Log Out
          </div>
          <div
            v-if="havePermission('manage_news')"
            v-bind:class="{ active: isActive('create-news') }"
            @click="gotoCreateNews"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('create-news') }"
              class="item-icon"
              size="20"
              >mdi-newspaper</v-icon
            >
            <span v-if="open">Create News</span>
          </div>
          <div
            v-if="havePermission('manage_news')"
            v-bind:class="{ active: isActive('manage-news') }"
            @click="gotoManageNews"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('manage-news') }"
              class="item-icon"
              size="20"
              >mdi-newspaper</v-icon
            >
            <span v-if="open">Manage News</span>
          </div>
          <div
            v-if="havePermission('edit_admin')"
            v-bind:class="{ active: isActive('manage-admins') }"
            @click="gotoManageAdmins"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('manage-admins') }"
              class="item-icon"
              size="20"
              >mdi-newspaper</v-icon
            >
            <span v-if="open">Manage Admins</span>
          </div>
          <div
            v-if="havePermission('featured_comp')"
            v-bind:class="{ active: isActive('manage-feature-company') }"
            @click="goToManageFeaturedCompany"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('manage-feature-company')}"
              class="item-icon"
              size="20"
              >mdi-newspaper</v-icon
            >
            <span v-if="open">Featured Company</span>
          </div>
           <div
            v-bind:class="{ active: isActive('campus-ambassador') }"
            @click="goToCampusAmbassador"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('campus-ambassador')}"
              class="item-icon"
              size="20"
              >mdi-newspaper</v-icon
            >
            <span v-if="open">Campus Ambassador</span>
          </div>
          <div
            v-if="havePermission('manage_campaigns')"
            v-bind:class="{ active: isActive('manage-email-campaign') }"
            @click="goToManageEmailCampaign"
            class="item"
          >
            <v-icon
              v-bind:class="{ active: isActive('manage-email-campaign')}"
              class="item-icon"
              size="20"
              >mdi-newspaper</v-icon
            >
            <span v-if="open">Email Campaign</span>
          </div>

          

        </div>
      </div>
      <div v-if="!phone"></div>

      <div class="contentContainer">
        <div v-if="phone && open" class="overlay" @click="open = false"></div>
        <div v-else>
          <div class="phone-nav" v-if="phone" @click="gotoDashboard">
            <img style="width: 5rem" src="@/assets/newDesign/logo.svg" />
          </div>
          <header class="top-header">
            <div class="row justify-content-end">
              <div v-if="phone && open"></div>
              <v-menu
                v-model="showDropdown"
                transition="slide-x-transition"
                :close-on-content-click="false"
                offset-y
                left
              >
                <template v-slot:activator="{ on }">
                  <v-badge
                    v-model="completeNess"
                    id="bdge"
                    style="margin-top: 0.8rem"
                    color="#ff6e38"
                    left
                    overlap
                  >
                    <template v-slot:badge>
                      <span>!</span>
                    </template>
                    <span class="user-icon" v-on="on"
                      ><v-icon
                        style="font-size: 2.2rem; color: var(--button-color)"
                        >mdi-account</v-icon
                      ><v-icon style="color: var(--button-color)"
                        >mdi-chevron-down</v-icon
                      ></span
                    >
                  </v-badge>
                </template>
                <div class="box-wrapper">
                  <div class="box-head">
                    <div style="font-size: 1.4rem; font-weight: bold">
                      {{ FIRST_LETTER_CAPITAL(user.name) }}
                    </div>
                    <div style="font-size: 1.6rem">{{ user.email }}</div>
                  </div>
                  <div class="box-body">
                    <div @click="signOutConfirmation" class="item-wrapper">
                      <div class="men-item">Log out</div>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
          </header>
          <div :key="changeKey" v-if="showPopup">
            <confirmation-popup
              v-on:on-click-cancel="showPopup = false"
              v-on:on-click-ok="signOutCallBack"
              v-bind="signOutPopUpProps"
            ></confirmation-popup>
          </div>
          <div id="info-part" class="top-padding">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationPopup from "../global-components/confirmation-pop-up";
import { PHONE } from "../../globalFunctions";
import { FIRST_LETTER_CAPITAL } from "../../filters";
import { GET_API } from "../../Api/public_api";
export default {
  components: {
    ConfirmationPopup,
  },
  data: function () {
    return {
      FIRST_LETTER_CAPITAL: FIRST_LETTER_CAPITAL,
      showDropdown: false,
      completeNess: null,
      phone: PHONE(),
      user: this.$constants.getOwnerInfo(),
      changeKey: 0,
      showManageItems: false,
      showManagePlanItems: false,
      showPopup: false,
      signOutPopUpProps: {
        open: false,
        title: "Confirmation",
        message: "Do you really want to sign out now?",
      },
      drawer: false,
      open: true,
      activeTab: "",
      super_admin: false,
      admin_permissions: [],
    };
  },
  methods: {
    havePermission(text) {
      const self = this;
      if (self.super_admin) return true;
      for (let i = 0; i < self.admin_permissions.length; i++) {
        if (
          self.$constants.ADMIN_ACTION_TEXT[text] === self.admin_permissions[i]
        ) {
          return true;
        }
      }
      return false;
    },
    updateTab(path, q) {
      const self = this;
      let tab = path;
      if (tab.slice(7) === "manage-users") {
        if (q) {
          self.activeTab = q;
        }
        self.showManageItems = true;
      } else if (tab.slice(7) === "manage-plans") {
        if (q) {
          self.activeTab = q;
        }
        self.showManagePlanItems = true;
      } else {
        self.activeTab = tab.slice(7);
      }
    },
    openMenu(menu) {
      const self = this;
      this.open = true;
      switch (menu) {
        case "manage-users":
          self.open && (self.showManageItems = !self.showManageItems);
          self.showManagePlanItems = false;
          break;
        case "manage-plans":
          self.open && (self.showManagePlanItems = !self.showManagePlanItems);
          self.showManageItems = false;
          break;
      }
    },
    isActive(tab) {
      return this.activeTab.toLowerCase() === tab.toLowerCase();
    },
    gotoCreateNews() {
      const self = this;
      self.activeTab = "create-news";
      self.$router.push({ name: "create-news" }).catch(function () {});
    },
    gotoManageAdmins() {
      const self = this;
      self.activeTab = "manage-admins";
      self.$router.push({ name: "manage-admins" }).catch(function () {});
    },
    gotoManageNews() {
      const self = this;
      self.activeTab = "manage-news";
      self.$router.push({ name: "manage-news" }).catch(function () {});
    },
    gotoDashboard() {
      const self = this;
      self.$router.push({ name: "adminDashboard" }).catch(function () {});
    },
    goToPendingJobs() {
      this.$router.push({ name: "adminPendingJobs" }).catch(function () {});
    },
    goToMessagePage() {
      this.$router.push({ name: "message" }).catch(function () {});
    },
    gotoAllJobs() {
      this.activeTab = "all-jobs";
      this.$router.push({ name: "all-jobs" }).catch(function () {});
    },
    goToErrorLog() {
      this.activeTab = "error-log";
      this.$router.push({ name: "error-log" }).catch(function () {});
    },
    goToMobileLog() {
      this.$router.push({ name: "mobileLog" }).catch(function () {});
    },
    goToManageUsers(param) {
      this.activeTab = param;
      this.$router
        .push({ name: "adminManageUsers", query: { q: param } })
        .catch(function () {});
    },
    goToManagePlans(param) {
      this.activeTab = param;
      this.showManagePlanItems = true;
      this.$router
        .push({ name: "adminManagePlans", query: { q: param } })
        .catch(function () {});
    },
    goToPostAJob() {
      this.activeTab = ""
      this.$router.push({ name: "adminPostAJob" }).catch(function () {});
    },
    goToManageFeaturedCompany() {
      this.activeTab = "manage-feature-company"
      this.$router.push({ name: "manage-feature-company" }).catch(function () {});
    },
    goToManageEmailCampaign() {
      this.activeTab = "manage-email-campaign"
      this.$router.push({ name: "manage-email-campaign" }).catch(function () {});
    },
    goToCampusAmbassador() {
      this.activeTab = "campus-ambassador"
      this.$router.push({ name: "campus-ambassador" }).catch(function () {});
    },
    goToCreateCompany() {
      this.activeTab = "create-company";
      this.$router.push({ name: "create-company" }).catch(function () {});
    },
    goHandoverCompany() {
      this.$router.push({ name: "handover" }).catch(function () {});
    },
    signOutCallBack: function () {
      const self = this;
      self.$store.dispatch("signOut").then(function (response) {
        if (response.status === 200 || response.status === 401) {
          self.$router.push({ name: "landingPage" }).catch(function () {});
        } else {
          self.$router.push({ name: "adminDashboard" }).catch(function () {});
        }
      });
    },
    signOutConfirmation: function () {
      const self = this;
      self.changeKey++;
      self.showPopup = true;
      self.signOutPopUpProps.open = true;
    },
  },
  mounted() {
    const self = this;
    let info = JSON.parse(localStorage.getItem("user"));
    self.super_admin = !!info.super_admin;
    if (!self.super_admin) {
      self.admin_permissions = info.admin_permissions;
    }
    GET_API()
      .then(function () {})
      .catch(function () {});
    self.updateTab(self.$route.path, self.$route.query.q);
    if (self.phone) {
      self.open = false;
    } else {
      if (document.getElementById("info-part").clientWidth < 1100) {
        self.open = false;
        self.showManageItems = false;
        self.showManagePlanItems = false;
      }
    }
  },
  watch: {
    "$route.path"(newQ, oldQ) {
      if (newQ !== oldQ) {
        this.updateTab(newQ);
      }
    },
  },
};
</script>

<style scoped>
.overlay {
  height: 100vh;
  width: 100%;
  background-color: grey;
  position: absolute;
  top: 0;
}
.message-icon {
  /*margin-top:.8rem;*/
  color: var(--button-color);
  background-color: #e5e5ea;
  padding: 0.8rem;
  font-size: 2.2rem;
  border-radius: 5rem;
}
.unreadBox {
  background-color: var(--synop-select-color);
}
.arrow-icon {
  float: right;
  color: var(--link-color);
}
.test {
  height: 100vh;
  width: 100vw;
  position: fixed;
  background-color: white;
  top: 0;
  left: 0;
}
.wrapper {
  display: grid;
  grid-template-columns: 25rem 3rem auto;
  /* grid-template-areas: "sidebar sidebar"
                              "contentContainer contentContainer"; */
}
.wrapperClose {
  display: grid;
  grid-template-columns: 7rem 3rem auto;
}
.wrapperPhone {
  display: grid;
  grid-template-columns: 0rem 100%;
}
.sidebar {
  position: relative;
  width: 25rem;
  background-color: #fafafa;
  height: 100vh;
  box-shadow: 0.2rem 0 0.8rem 0 rgba(0, 0, 0, 0.08);
}
.sidebarOpen {
  position: relative;
  width: 25rem;
  background-color: #fafafa;
  height: 100vh;
  box-shadow: 0.2rem 0 0.8rem 0 rgba(0, 0, 0, 0.08);
  /* animation: open 0.5s ease; */
}
/* @keyframes open{
    from{
      width:.0rem;
    }
    to{
      width: 25.0rem;
    }
  } */
.contentContainer {
  width: auto;
  background-color: white;
  margin: 2rem;
  height: 100vh;
  overflow: auto;
  /*margin-top: 8.0rem;*/
}
.top-padding {
  padding-top: 0.5rem;
}

.top-header {
  position: relative;
  margin: 0.2rem 2rem 2rem 2rem;
}
.hello {
  font-size: 1.2rem;
  line-height: 1.33;
  text-align: right;
  color: #050505;
}
.top-name-text {
  font-size: 1.6rem;
  font-weight: 500;
  color: #121212;
}
.sidebarClose {
  position: relative;
  width: 7rem;
  background-color: #fafafa;
  height: 100vh;
  /* animation: close 0.5s ease; */
}
.sidebarPhone {
  position: relative;
  width: 0rem;
  background-color: #fafafa;
  height: 100vh;
}
.menu-button-patch {
  position: absolute;
  top: 2.2rem;
  height: 4.8rem;
  width: 0.8rem;
  z-index: 100;
  background-color: #fafafa;
  right: -0.2rem;
}
.menubutton {
  position: absolute;
  top: 2.2rem;
  right: -4.8rem;
  padding: 0.8rem;
  height: 4.8rem;
  width: 4.8rem;
  box-shadow: 0 0.3rem 0.6rem 0 rgba(0, 0, 0, 0.16);
  background-color: #fafafa;
  color: var(--button-color);
  border-top-right-radius: 2.4rem;
  border-bottom-right-radius: 2.4rem;
  cursor: pointer;
}
.logo {
  padding: 1.5rem;
  background-color: #fafafa;
  height: 7rem;
  cursor: pointer;
}
.profile {
  padding: 2.5rem 0 2rem 0;
  position: relative;
  background-color: #fafafa;
  /*height: 15rem;*/
}
.image {
  width: 100%;
  height: 100%;
}
.proPic {
  height: 10rem;
  width: 10rem;
  background-color: rgba(255, 255, 255, 0.9);
  margin: 0 6.5rem 0 7.5rem;
  /*border: .1rem dashed #cccccc;*/
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}
.profilePhone {
  display: none;
}
.profileClose {
  padding: 0.7rem;
  position: relative;
  width: 4.5rem;
  /* background-color: #efefef; */
  height: 7rem;
  overflow: hidden;
}
.proPicClose {
  height: 4.5rem;
  width: 4.5rem;
  background-color: white;
  margin-top: 0.7rem;
  margin-left: 0.7rem;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}
.pro-pic-upload-wrapper {
  height: 7rem;
  width: 10rem;
  background-color: rgba(0, 0, 0, 0.5);
  /*border: .1rem solid #cccccc;*/
  border-bottom-left-radius: 11rem;
  border-bottom-right-radius: 11rem;
  overflow: hidden;
  position: absolute;
  top: 5.5rem;
  display: none;
}
.xyz {
}
.xyz:hover .pro-pic-upload-wrapper {
  display: block;
}
.user-name {
  padding: 0.5rem;
  position: relative;
  color: #121212;
}
.log-status {
  position: relative;
  padding: 0.1rem;
  color: #121212;
}
.content-container {
  margin-left: 32rem;
  margin-right: 7rem;
  margin-top: 5vh;
}
.items {
  /*background-color: #f7f7f7;*/
  height: 80vh;
  overflow-y: auto;
}
.item {
  color: #121212;
  padding: 1rem;
  text-align: left;
  border-bottom: 0.1rem solid #fafafa;
  cursor: pointer;
  font-size: 1.6rem;
  line-height: 1.5;
  overflow: hidden;
}
.item-icon {
  padding: 0 1.5rem;
}
.user-icon {
  background-color: var(--synop-select-color);
  padding: 0.8rem;
  border-radius: 0.4rem;
  cursor: pointer;
}
.active {
  background-color: var(--synop-select-color);
  font-weight: bold;
  color: var(--link-color) !important;
}
.sub {
  padding-left: 6rem;
}
.box-wrapper {
  background-color: #ffffff;
  position: relative;
  min-width: 15rem;
}
.box-head {
  font-size: 1.4rem;
  padding: 3rem 2.4rem;
  color: #121212;
  background-color: #ffffff;
  border-bottom: 1px solid #e6e6e6;
}
.box-body {
  padding: 0;
}
.men-item {
  font-size: 1.6rem;
}
.item-wrapper {
  padding: 1rem 2.4rem;
  font-size: 1.6rem;
  text-align: left;
  cursor: pointer;
}
.item-wrapper:hover {
  background-color: var(--synop-select-color);
  color: var(--button-color);
}
.phone-nav {
  position: absolute;
  top: 0rem;
  right: 0rem;
  width: 100%;
  padding: 1rem 0rem;
  background-color: white;
  z-index: 99;
  box-shadow: 0rem 0.5rem 0.5rem rgba(0, 0, 0, 0.06);
}
@media (max-width: 1366px) {
  .wrapper {
    display: grid;
    grid-template-columns: 25rem 0rem auto;
    /* grid-template-areas: "sidebar sidebar"
                                "contentContainer contentContainer"; */
  }
  .wrapperClose {
    display: grid;
    grid-template-columns: 7rem 0rem auto;
  }
  .top-padding {
    margin-top: -2rem;
    padding-top: 1rem;
  }
}
@media (max-width: 600px) {
  .contentContainer {
    margin: 0rem;
    padding-top: 8.5rem;
    padding-bottom: 7rem;
  }
  .contentContainer::-webkit-scrollbar {
    display: none;
  }
  .top-padding {
    padding-top: 0rem;
    margin-top: 0rem;
  }
  .top-padding {
    padding-top: 0rem;
  }
  .menubutton {
    z-index: 999;
    box-shadow: none;
    background-color: white;
    top: 1rem;
  }
  .menu-button-patch {
    display: none;
  }
}
</style>
